export default "__VITE_ASSET__DOt0LIVt__"